import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import env from "dotenv";
import 'bootstrap/dist/css/bootstrap.min.css';
import store from "./store/store";
import Routes from "./main/routes";
import {Provider} from "react-redux";


ReactDOM.render(
    <Provider store={store}>
        <Routes/>
    </Provider>, document.getElementById('root'));

env.config();

serviceWorker.unregister();